import { useCallback, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import { annotationsFeatureSelector } from '@store/common/selectors';
import { annotationAtom } from '@src/atoms/toggles';
import { dispatchAnnotationEvent } from '../annotationEvent';

function useAnnotateBrush({ instance, appliedFilter, metricKey, enabled }) {
  const annotationsToggled = useAtomValue(annotationAtom);
  const featureEnabled = useSelector(annotationsFeatureSelector) && annotationsToggled && enabled;

  const handleClickToAnnotate = useCallback(
    (params) => {
      const pointInPixel = [params.offsetX, params.offsetY];
      const pointInGrid = instance.convertFromPixel('grid', pointInPixel);

      dispatchAnnotationEvent({
        appliedFilter,
        metricKey,
        sliceInterval: [0, pointInGrid[0]],
      });
    },
    [instance, appliedFilter, metricKey],
  );

  useEffect(() => {
    if (instance && featureEnabled) {
      instance.getZr().on('click', handleClickToAnnotate);
      return () => {
        if (instance && instance.getZr()) {
          instance.getZr().off('click', handleClickToAnnotate);
        }
      };
    }
  }, [instance, featureEnabled, handleClickToAnnotate]);
}

export default useAnnotateBrush;
